import React from "react";

const AsideContext = React.createContext({
  asideOpen: false,
  toggleAside: () => {},
});

export default AsideContext;
